import controller from './tabs.controller';

const template = require('./tabs.html');

export default {
    bindings: {
        searchQuery: '<',
        tabId: '<'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/tabs/tabs.component.js